import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="lang-toggle">
      <button
        className={`lang-btn ${i18n.language === "ru" ? "active" : ""}`}
        onClick={() => changeLanguage("ru")}
      >
        🇷🇺 RU
      </button>
      <button
        className={`lang-btn ${i18n.language === "en" ? "active" : ""}`}
        onClick={() => changeLanguage("en")}
      >
        🇺🇸 EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
